const LAZY_IFRAME_SELECTOR = "iframe[data-src], iframe[data-srcdoc]";

const OBSERVER_OPTIONS = {
  root: null,
  rootMargin: "200px",
  threshold: 0.1,
};

const loadIframe = (iframe: HTMLIFrameElement) => {
  // `srcdoc` antes de `src`: com o `srcdoc` já aplicado, escrever o `src` não
  // navega (ele vira fallback). Na ordem inversa o browser carregaria o `src`.
  const dataSrcdoc = iframe.getAttribute("data-srcdoc");
  if (dataSrcdoc !== null) {
    iframe.srcdoc = dataSrcdoc;
    iframe.removeAttribute("data-srcdoc");
  }

  const dataSrc = iframe.getAttribute("data-src");
  if (dataSrc !== null) {
    iframe.src = dataSrc;
    iframe.removeAttribute("data-src");
  }
};

export const observeLazyIframes = (root: ParentNode): (() => void) => {
  const observer = new IntersectionObserver((entries, self) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      loadIframe(entry.target as HTMLIFrameElement);
      self.unobserve(entry.target);
    });
  }, OBSERVER_OPTIONS);

  root
    .querySelectorAll<HTMLIFrameElement>(LAZY_IFRAME_SELECTOR)
    .forEach((iframe) => observer.observe(iframe));

  return () => observer.disconnect();
};

export const setupLazyLoading = () => {
  observeLazyIframes(document);
};
